import { render } from "./IconTriangle.vue?vue&type=template&id=6fb33b75"
import script from "./IconTriangle.vue?vue&type=script&lang=js"
export * from "./IconTriangle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__